import React, { useEffect } from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

const faqs = [
    {
        question: "What is Biblivium?",
        answer:
            "A global, curated literature platform that highlights books from every corner of the world.",
    },
    {
        question: "Who is it for?",
        answer:
            "Anyone eager to explore world literature; casual readers, students, or bibliophiles alike.",
    },
    {
        question: "Do I need to know multiple languages?",
        answer:
            "No. Summaries and context are available in English while keeping original text accessible.",
    },
    {
        question: "Can I explore by genre or era?",
        answer:
            "Yes. Filtering by era, genre, and theme is coming soon for more targeted exploration.",
    },
    {
        question: "How is this different from other platforms?",
        answer:
            "Biblivium focuses on clarity, context, and minimalism; letting the books speak for themselves.",
    },
];

export default function FifthSection() {
    useEffect(() => {
        AOS.init({
            duration: 900,
            easing: "ease-out-cubic",
            once: false,
        });
    }, []);

    return (
        <section
            className="py-5"
            style={{ backgroundColor: "#ffffff" }}
            data-aos="fade-up"
        >
            <Container>
                {/* Heading */}
                <Row
                    className="justify-content-center text-center mb-5"
                    data-aos="fade-up"
                >
                    <Col lg={8}>
                        <div
                            className="d-inline-block px-3 py-1 mb-3 rounded-pill bg-white shadow-sm border"
                            data-aos="zoom-in"
                            data-aos-delay="100"
                        >
                            <span className="fw-semibold text-dark">FAQ</span>
                        </div>

                        <h2
                            className="fw-bold"
                            style={{ maxWidth: "600px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            Curious about Biblivium? We get that.
                        </h2>
                    </Col>
                </Row>

                {/* FAQ Items */}
                <Row className="justify-content-center">
                    <Col xs={12} md={10} lg={8}>
                        <Accordion flush>
                            {faqs.map((faq, index) => (
                                <Accordion.Item
                                    key={index}
                                    eventKey={index.toString()}
                                    className="mb-3 shadow-sm rounded-3"
                                    data-aos="zoom-in-up"
                                    data-aos-delay={300 + index * 100}
                                >
                                    <Accordion.Header>
                                        {faq.question}
                                    </Accordion.Header>
                                    <Accordion.Body className="text-muted">
                                        {faq.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            </Container>
            <style>
                {`
                    .accordion-button {
                        background-color: #ffffff !important;
                        color: #000000 !important;
                        box-shadow: none !important;
                    }
                    .accordion-button:not(.collapsed) {
                        background-color: #ffffff !important;
                        color: #000000 !important;
                    }
                    .accordion-button:focus {
                        box-shadow: none !important;
                    }
                `}
            </style>
        </section>
    );
}
